/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Grid = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../helpers");

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Grid, _React$PureComponent);

  function Grid() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.componentDidMount = function componentDidMount() {
    require('../../css/flex-grids');
  };

  _proto.render = function render() {
    var _classnames;

    var _this$props = this.props,
        gutter = _this$props.gutter,
        justifyContent = _this$props.justifyContent,
        flexDirection = _this$props.flexDirection,
        props = _objectWithoutPropertiesLoose(_this$props, ["gutter", "justifyContent", "flexDirection"]);

    var newProps = (0, _helpers.mergeProps)(props, {
      className: (0, _classnames2["default"])('grid', gutter ? '' : 'grid-nogutter', (_classnames = {}, _classnames["justify-content-" + justifyContent] = justifyContent, _classnames["flex-direction-" + flexDirection] = flexDirection, _classnames))
    });
    return _react["default"].createElement("div", newProps);
  };

  return Grid;
}(_react["default"].PureComponent);

exports.Grid = Grid;

_defineProperty(Grid, "propTypes", {
  gutter: _propTypes["default"].bool,
  justifyContent: _propTypes["default"].oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),
  flexDirection: _propTypes["default"].oneOf(['row', 'row-reverse', 'column', 'column-reverse'])
});

_defineProperty(Grid, "defaultProps", {
  gutter: true
});

;